<template>
  <div>
    <!-- <pre>{{ formStates}}</pre>-->
    <!-- <pre>{{ formStates.userproduct.customerproductstypeobj.Type }}</pre> -->
    <!-- <pre>{{ formState.userproduct }}</pre> -->
    <a-row>
 <a-col class="p-1" flex="2" :order="1"> 
        <a-form-item has-feedback label="หมวดหมู่ประเภทหลัก" :name="['userproduct', 'customerproduct']" :rules="{
          required: true,
          message: 'กรุณากรอก',
        }">   
          <a-select v-if="list_category_1 != null" show-search :filter-option="filterOption"
            v-model:value="formState.userproduct.category_1" :options="list_category_1.map((city) => ({
              value: city.Category_1_Code,
              label: city.Category_1
            }))"  @change="handleChange">
          </a-select> 
        </a-form-item>
        <a-col class="p-1" flex="1" :order="3">
                <a-form-item
                    has-feedback
                    label="รูปสินค้า"
                    :name="['userproduct', 'heartyanname']"
                > 
                    <div v-if="formState.userproduct?.productdetail && formState.userproduct?.productdetail
                                        ?.productimage"> 
                        <div
                            v-if="formState.userproduct?.productdetail
                                        ?.productimage && 
                                JSON.parse(
                                    formState.userproduct?.productdetail
                                        ?.productimage
                                )?.length>0
                            "
                        > 
                        <a-image
                            :width="150"
                            :src="JSON.parse(
                                    formState.userproduct?.productdetail
                                        ?.productimage
                                )" 
                            />
                        </div>
                    </div>
                    <div v-else> 
                        <a-image
                            :width="150"
                            src="https://www.antdv.com/#error"
                            fallback="data:image/png;base64,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"
                        />
                    </div>
                </a-form-item>
            </a-col>
      </a-col>  
      <!-- <a-col class="p-1" flex="2" :order="2">
        <a-form-item has-feedback label="หมวดหมู่ประเภทย่อย" :name="['userproduct', 'heartyanname']" :rules="{
          required: true,
          message: 'กรุณากรอก',
        }"> 
          <a-select @click="setThree()" @change="setThree()" show-search :filter-option="filterOption" style="width: 100%"
            v-if="list_category_2 != null" v-model:value="formState.userproduct.category_2" :options="list_category_2.map((city) => ({
              value: city.Category_2,
              label: city.Category_2,
            }))
              "></a-select>
        </a-form-item> 
      </a-col> -->
      <!-- <a-col class="p-1" flex="2" :order="3">
        <a-form-item has-feedback label="หมวดหมู่รูปแบบ" :name="['userproduct', 'heartyanname']" :rules="{
          required: true,
          message: 'กรุณากรอก',
        }"> 

          <a-select @click="setFour()" @change="setFour()" show-search :filter-option="filterOption" style="width: 100%"
            v-if="list_category_3 != null" v-model:value="formState.userproduct.category_3" :options="list_category_3.map((city) => ({
              value: city.Category_3,
              label: city.Category_3,
            }))
              "></a-select>
        </a-form-item>
      </a-col> -->
      <!-- <a-col class="p-1" flex="2" :order="4">
        <a-form-item has-feedback label="สี/ไซส์" :name="['userproduct', 'heartyanname']" :rules="{
          required: true,
          message: 'กรุณากรอก',
        }"> 
          <a-select @change="handleChange" show-search :filter-option="filterOption" style="width: 100%"
            v-if="list_category_4 != null" v-model:value="formState.userproduct.category_4" :options="list_category_4.map((city) => ({
              value: city.Category_4,
              label: city.Category_4,
            }))
              "></a-select>
        </a-form-item> 
      </a-col> -->
    </a-row>
    <a-col flex="2" :order="5">
      <a-form-item has-feedback label="หมายเหตุหัวใจยันต์" :name="['userproduct', 'introductionyan']" :rules="{
        required: false,
        message: 'กรุณากรอก',
      }">
        <a-textarea v-model:value="formState.userproduct.introductionyan" @change="OnChangeEmitIntroductionyan()"
          allow-clear />
      </a-form-item>
    </a-col>
  </div>
</template>
<script>
import { defineComponent, reactive, ref, watch, onMounted } from "vue";
import { Form } from "ant-design-vue";
import locale from "ant-design-vue/es/date-picker/locale/th_TH";
import axios from "axios";
import BzbsUser from "@/core/UserManagement/callapi/BzbsUser";
import { formStateStore } from "@/store/storebackoffice";
import _ from "lodash";
// import Baseinput from "../form/Baseinput.vue";
export default defineComponent({
  components: {},
  props: {
    formStates: null,
  },
  emits: ["ProductstypeData"],
  setup(props, { emit }) {
    const Type = ref("")
    const gender = ref("1");
    const queyan = ref("1");
    const typebirthday = ref("1");

    const is_paid_delivery = ref("1");

    const agegender = ref("18");
    const formState = reactive(props.formStates);
    formState.userproduct.customerproduct = formState.userproduct.customerproductssize
    formState.userproduct.sub_customerproduct = formState.userproduct.heartyanname


    // formState = props.formState
    const productData = ["ยันต์เขียนสด", "วัตถุมงคล"];
    // const sights = reactive();
    const sights = {
      หมวดหมู่ประเภทหลัก: [],
      หมวดหมู่ประเภทย่อย: [],
      หมวดหมู่รูปแบบ: [],
      ขนาด: [],
    };
    const list_category_1 = ref(null);
    const list_category_2 = ref([]);
    const list_category_3 = ref([]);
    const list_category_4 = ref([]);
    const productdetail = ref(null);
    const yanname = [
      {
        label: "หัวใจยันต์1",
        value: "หัวใจยันต์1",
      },
      {
        label: "หัวใจยันต์2",
        value: "หัวใจยันต์2",
      },
      {
        label: "หัวใจยันต์3",
        value: "หัวใจยันต์3",
      },
      {
        label: "หัวใจยันต์4",
        value: "หัวใจยันต์4",
      },
    ];

    // watch(
    //   () => formState.userproduct.customerproductstype,
    //   () => {
    //     if (formState.userproduct.customerproductstype == "ยันต์เขียนสด") {
    //       queryyan("yan");
    //     } else if (formState.userproduct.customerproductstype == "วัตถุมงคล") {
    //       queryyan("mobile");
    //     }
    //   }
    // );
    onMounted(() => { 
      apicategoryproduct();
    });

    const apicategoryproduct = async () => {

      var params = {
        "category": "category_1",
        "type": formState.userproduct.customerproductstypeobj.Type
      }
      await BzbsUser.apicategoryproduct(params)
        .then(res => {
           
          console.log("apicategoryproduct : ", res.data);
          list_category_1.value = res.data
          // setupselect(res);
        })
        .catch(error => {
          console.log(error);
        });
    }
    // let path = window.location.host.includes("localhost")
    //   ? "http://localhost:8090"
    //   : process.env.VUE_APP_API_BASE_URL;
    // return axios.get(path + "/api/getmasterproduct/" + filename).then((res) => {
    //   var orderres = res.data.sort((a, b) => { 
    //     return parseInt(a.Category_1_Code) - parseInt(b.Category_1_Code);
    //   });



    //   setupselect(res);
    // });


    // const setupselect = (res) => {

    //   res.data?.forEach((element) => {
    //     sights["หมวดหมู่ประเภทหลัก"].push({ label: element.Category_1, value: element.Category_1 });
    //     // sights["หมวดหมู่ประเภทย่อย"].push({ label: element["หมวดหมู่ประเภทย่อย"], value: element["รหัสประเภทย่อย"] });
    //     sights["หมวดหมู่รูปแบบ"].push({ label: element.Category_2, value: element.Category_2_Code });
    //     var objheartyan = {};
    //     objheartyan.sub_type = element.Category_1;
    //     objheartyan.productname = element.Name;
    //     objheartyan.productsize = element.Category_3;
    //     objheartyan.code_productsize = element.Category_3_Code;
    //     objheartyan.price = element.Price;
    //     objheartyan.originalprice = element.Cost;
    //     objheartyan.product_barcode = element.ProductCode;
    //     objheartyan.price_destination = element["เก็บปลายทาง"];
    //     objheartyan.productcode = element.ProductCode;
    //     objheartyan.code_type = element.Category_1_Code;
    //     objheartyan.Category_1 = element.Category_1;
    //     objheartyan.Category_1_Code = element.Category_1_Code;
    //     objheartyan.Category_2 = element.Category_2;
    //     objheartyan.Category_2_Code = element.Category_2_Code;
    //     objheartyan.Category_3 = element.Category_3;
    //     objheartyan.Category_3_Code = element.Category_3_Code;
    //     objheartyan.Category_4 = element.Category_4;
    //     objheartyan.Category_4_Code = element.Category_4_Code;

    //     objheartyan.code_pattern = element.Category_2_Code;
    //     sights["หมวดหมู่ประเภทย่อย"].push(objheartyan);
    //   });
    //   let productlist = sights["หมวดหมู่ประเภทหลัก"].filter((c, index) => {
    //     return sights["หมวดหมู่ประเภทหลัก"].indexOf(c) === index;
    //   });

    //   productlist = getUniqueListBy(productlist, 'label')
    //   console.log(productlist)
    //   list_category_1.value = productlist;
    // };
    const getUniqueListBy = (array, key) => {
      return [...new Map(array.map(item => [item[key], item])).values()]
    }


    const formRef = ref();
    const dynamicValidateForm = reactive({
      sights: [],
      area: undefined,
    });
    watch(
      () => dynamicValidateForm.area,
      () => {
        dynamicValidateForm.sights = [];
      }
    );

    const setTwo = async () => {
       
      list_category_2.value = []
      var params = {
        "category": "category_2",
        "type": formState.userproduct.customerproductstypeobj.Type,
        "category_selected_1": formState.userproduct.category_1,
      }
      await BzbsUser.apicategoryproduct(params)
        .then(res => {
          console.log("apicategoryproduct2 : ", res.data);
          list_category_2.value = res.data
        })
        .catch(error => {
          console.log(error);
        });
    }

    const setThree = async () => {
      list_category_3.value = []
      var params = {
        "category": "category_3",
        "type": formState.userproduct.customerproductstypeobj.Type,
        "category_selected_1": formState.userproduct.category_1,
        "category_selected_2": formState.userproduct.category_2,
      }
      await BzbsUser.apicategoryproduct(params)
        .then(res => {
          console.log("apicategoryproduct : ", res.data);
          list_category_3.value = res.data
        })
        .catch(error => {
          console.log(error);
        });
    }
    const setFour = async () => {
      list_category_4.value = []
      var params = {
        "category": "category_4",
        "type": formState.userproduct.customerproductstypeobj.Type,
        "category_selected_1": formState.userproduct.category_1,
        "category_selected_2": formState.userproduct.category_2,
        "category_selected_3": formState.userproduct.category_3,
      }
      await BzbsUser.apicategoryproduct(params)
        .then(res => {
          console.log("apicategoryproduct : ", res.data);
          list_category_4.value = res.data
        })
        .catch(error => {
          console.log(error);
        });
    }
    // const settwo_ = () => {

    //   var filter_customerproductssize = list_category_1.value.filter(item => item.value == formState.userproduct.customerproduct)
    //   if (filter_customerproductssize.length) {
    //     formState.userproduct.customerproductssize = filter_customerproductssize[0].label
    //   }


    //   formState.userproduct.sub_customerproduct = ""
    //   list_category_2.value = []

    //   emit("ProductstypeData", formState.userproduct);
    //   formState.userproduct.size = "";
    //   let listobj = [];
    //   sights["หมวดหมู่ประเภทย่อย"].filter((c) => {
    //     listobj.push(c);
    //   });

    //   listobj = getUniqueListBy(listobj, 'Category_2')
    //   list_category_2.value = listobj;
    // };

    // const setThree = () => {

    //   var filter_customerproductssize = list_category_2.value.filter(item => item.value == formState.userproduct.customerproduct)
    //   if (filter_customerproductssize.length) {
    //     formState.userproduct.customerproductssize = filter_customerproductssize[0].label
    //   }


    //   formState.userproduct.sub_customerproduct = ""
    //   list_category_2.value = []

    //   emit("ProductstypeData", formState.userproduct);
    //   formState.userproduct.size = "";
    //   let listobj = [];
    //   sights["หมวดหมู่ประเภทย่อย"].filter((c) => {
    //     listobj.push(c);
    //   });

    //   listobj = getUniqueListBy(listobj, 'Category_2')
    //   list_category_2.value = listobj;
    // };
    const sizepattern = ref([]);



    // const setthree = () => {
    //   sizepattern.value = []

    //   emit("ProductstypeData", formState.userproduct);
    //   // formState.userproduct.size = "";
    //   let listobj = [];
    //   sights["ขนาด"].filter((c) => {

    //     if (c.code_sub_product_type == formState.userproduct.sub_customerproduct) {
    //       listobj.push(c);
    //     }
    //   });
    //   sizepattern.value = listobj;
    // };
    const removeSight = (item) => {
      let index = dynamicValidateForm.sights.indexOf(item);

      if (index !== -1) {
        dynamicValidateForm.sights.splice(index, 1);
      }
    };

    const addSight = () => {
      dynamicValidateForm.sights.push({
        value: undefined,
        price: undefined,
        typebirthday: "1",
        id: Date.now(),
      });
    };

    const onFinish = (values) => {
      console.log("formState :", formState);
      emit("update:value", formState);
      emit("closemodal", false);
      formItemContext.onFieldChange();
      console.log("Received values of form:", values);
      console.log("dynamicValidateForm:", dynamicValidateForm);
    };
    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };
    const isdisabled = (sights) => {
      if (sights.typebirthday == 1) {
        delete sights.birthday;
        delete sights.age;
        return true;
      } else {
        sights.age = calculateAge(sights);
      }
    };

    const calculateAge = (sights) => {
      var ageDifMs = Date.now() - new Date(sights.birthday).getTime();
      var ageDate = new Date(ageDifMs); // miliseconds from epoch
      if (Math.abs(ageDate.getUTCFullYear() - 1970)) {
        return Math.abs(ageDate.getUTCFullYear() - 1970);
      } else {
        return 0;
      }
    };
    const formItemContext = Form.useInjectFormItemContext();
    const fromchange = () => {
      console.log("formState :", formState);
      emit("update:value", formState);
      formItemContext.onFieldChange();
    };
    const OnChangeEmit = () => {
      emit("ProductstypeData", formState.userproduct);
    };
    const OnChangeEmitIntroductionyan = () => {
      emit("ProductstypeData", formState.userproduct);
    };
    const handleChange = (value) => {
      console.log("handleChange ", value)
       

      var filterdata = list_category_1.value.filter(item => item.Category_1_Code == formState.userproduct.category_1)
      console.log("filterdata ", filterdata)
      if (filterdata.length) {
        formState.userproduct.productprice = filterdata[0].Price;
        formState.userproduct.originalprice = filterdata[0].Cost;
        // formState.userproduct.productdetail = []
        formState.userproduct.heartyanname = filterdata[0].Category_1
        // formState.userproduct.productdetail = filterdata;
        formState.userproduct.productcode = filterdata[0].ProductCode;

        formState.userproduct.productname = filterdata[0].Category_1
        formState.userproduct.product_barcode = filterdata[0].ProductCode;
        formState.userproduct.price_destination = filterdata[0].CashOnDelivery;
        formState.userproduct.productcode = filterdata[0].ProductCode;
        formState.userproduct.qty = 1 
        formState.userproduct.shotness = filterdata[0]?.Desc;
      }
      // formState.userproduct.productdetail = null

      formState.userproduct.productdetail = _.transform(filterdata[0], function (result, val, key) {
        result[key?.toString().toLowerCase()] = val;
      });;


    };
    const filterOption = (input, option) => {

      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    watch(
      () => formState.userproduct.category_1,
      () => { 
        // formState.userproduct.category_2= ""
        // formState.userproduct.category_3= ""
        // formState.userproduct.category_4= "" 
        // formState.userproduct.productprice = ""
        // formState.userproduct.originalprice = "" 
        // formState.userproduct.heartyanname = "" 
        // formState.userproduct.productcode = "" 
        // formState.userproduct.productname =  ""
        // formState.userproduct.product_barcode =  ""
        // formState.userproduct.price_destination = "" 
        // formState.userproduct.qty = "" 
 
      }
    );
    return {
      OnChangeEmit,
      OnChangeEmitIntroductionyan,
      locale,
      formRef,
      dynamicValidateForm,
      onFinish,
      removeSight,
      addSight,
      sights,
      gender,
      agegender,
      queyan,
      is_paid_delivery,
      formState,
      fromchange,
      yanname,
      typebirthday,
      isdisabled,
      calculateAge,
      onFinishFailed,
      productData,
      list_category_1,
      list_category_2,
      list_category_3,
      list_category_4,
      sizepattern,
      setTwo,
      setThree,
      setFour,
      productdetail,
      handleChange,
      filterOption,
      formStateStore
    };
  },
});
</script>